/**
 * ChatNotesPanel — l'unico punto delle note della chat (pulsante "Note" in
 * testata e voce "Note" del pannello laterale). Contiene sia la nota della
 * chat sia la nota sulla scheda del Lead/Cliente, ben separate.
 */

import { X, StickyNote } from 'lucide-react';
import { useWhatsAppAgentStore } from '@/lib/stores/whatsappAgentStore';
import { iconTip } from '@/components/messages/ChatTooltip';
import { ChatNotesSection } from './ChatNotesSection';

interface Props {
  chatJid: string;
  organizationId: string;
  isOpen: boolean;
  onClose: () => void;
}

export function ChatNotesPanel({ chatJid, organizationId, isOpen, onClose }: Props) {
  const assignment = useWhatsAppAgentStore((s) => s.assignments.find((a) => a.chat_jid === chatJid));
  const clientId = assignment?.client?.id || null;
  const clientName = assignment?.client?.business_name || null;

  return (
    <div
      className={`absolute right-0 top-0 h-full w-80 max-w-full bg-white dark:bg-gray-900 border-l border-[rgba(55,53,47,0.09)] dark:border-white/10 flex flex-col transition-transform duration-200 z-20 ${
        isOpen ? 'translate-x-0' : 'translate-x-full pointer-events-none'
      }`}
      aria-hidden={!isOpen}
    >
      <div className="flex items-center gap-3 px-4 py-3 border-b border-[rgba(55,53,47,0.09)] dark:border-white/10 flex-shrink-0">
        <StickyNote className="w-4 h-4 text-[#5F5E5B] dark:text-white/70" />
        <h3 className="flex-1 text-sm font-semibold text-[#37352F] dark:text-white">Note</h3>
        <button onClick={onClose} className="p-1.5 rounded hover:bg-[rgba(55,53,47,0.06)] dark:hover:bg-white/10" {...iconTip('Chiudi note')}>
          <X className="w-4 h-4 text-[#5F5E5B] dark:text-white/70" />
        </button>
      </div>
      <div className="flex-1 min-h-0 p-4">
        {isOpen && (
          <ChatNotesSection chatJid={chatJid} organizationId={organizationId} clientId={clientId} clientName={clientName} />
        )}
      </div>
    </div>
  );
}
